/**
 * @flow
 * @relayHash 1327edde2f76029a05c388233f93c3af
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type SubscriptionTemplateLoaderFragment_viewer$ref = any;
export type SubscriptionTemplateLoaderQueryVariables = {|
  first?: ?number,
  offset?: ?number,
|};
export type SubscriptionTemplateLoaderQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: SubscriptionTemplateLoaderFragment_viewer$ref
  |}
|};
export type SubscriptionTemplateLoaderQuery = {|
  variables: SubscriptionTemplateLoaderQueryVariables,
  response: SubscriptionTemplateLoaderQueryResponse,
|};
*/


/*
query SubscriptionTemplateLoaderQuery(
  $first: Int
  $offset: Int
) {
  viewer {
    ...SubscriptionTemplateLoaderFragment_viewer_21Sbsv
    id
  }
}

fragment SubscriptionTemplateLoaderFragment_viewer_21Sbsv on Query {
  subscriptionTemplates(first: $first, offset: $offset) {
    edges {
      node {
        id
        code
        name
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "offset",
    "type": "Int",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "offset",
    "variableName": "offset"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SubscriptionTemplateLoaderQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "SubscriptionTemplateLoaderFragment_viewer",
            "args": (v1/*: any*/)
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SubscriptionTemplateLoaderQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "subscriptionTemplates",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "SubscriptionTemplateNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "SubscriptionTemplateNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SubscriptionTemplateNode",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "code",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "name",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v2/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "SubscriptionTemplateLoaderQuery",
    "id": null,
    "text": "query SubscriptionTemplateLoaderQuery(\n  $first: Int\n  $offset: Int\n) {\n  viewer {\n    ...SubscriptionTemplateLoaderFragment_viewer_21Sbsv\n    id\n  }\n}\n\nfragment SubscriptionTemplateLoaderFragment_viewer_21Sbsv on Query {\n  subscriptionTemplates(first: $first, offset: $offset) {\n    edges {\n      node {\n        id\n        code\n        name\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2a3134c163513bc9fff1af108f378d1b';
module.exports = node;
